import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import { bindActionCreators } from "redux";
import { isValNull, validateEmail } from "../../../utils";
import * as AttributeMapping from "../../../store/actions/AttributeMapping";
import { connect } from "react-redux";
import { isEmpty } from "lodash-es";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import Permission from "../../Common/Permission";
import MenuActionMappings from "../../../constants/Menu/MenuActionsMappings.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const AttributeMappingTopSection = (props) => {
  const [emailFilter, setEmailFilter] = useState("");
  const [isApplyEnabled, setIsApplyEnabled] = useState(false);
  const [isAddNewEnabled, setIsAddNewEnabled] = useState(false);
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [isActionFilterEnabled, setIsActionFilterEnabled] = useState(false);
  const [isGetAttributeEnabled, setIsGetAttributeEnabled] = useState(false);
  const [actionList, setActionList] = useState([]);
  const {
    getUserAttributeList,
    userAttributeListData,
    actionListData,
    currentState,
    handleClick,
    getActionTypeList,
    userId,
    setInitialState,
    initialState,
    editState,
    setEditState,
    initialActionType,
    setInitialActionType,
  } = props;

  const handleApplyClick = () => {
    initialState.emailId = emailFilter;
    setInitialState(initialState);
    getActionTypeList(emailFilter);
    setIsAddNewEnabled(!isEmpty(currentState));
    setIsActionFilterEnabled(!isEmpty(currentState));
  };

  useEffect(() => {
    handleEditEnabled();
  }, [userAttributeListData]);

  useEffect(() => {
    setActionList(actionListData);
  }, [actionListData]);

  const handleEditEnabled = () => {
    setIsEditEnabled(!isEmpty(currentState) && !isEmpty(userAttributeListData));
  };

  const handleEmailFilterChange = (value) => {
    setEmailFilter(value);
    setIsApplyEnabled(validateEmail(value));
  };

  const handleActionFilterChange = (key, value) => {
    setInitialActionType(value);
    setIsGetAttributeEnabled(!isEmpty(currentState) && !isEmpty(actionList));
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleGetUserAttributeClick = () => {
    getUserAttributeList(userId, initialActionType);
    editState.action = initialActionType;
    setEditState(editState);
  };

  const allActions = MenuActionMappings[MenuNames.ATTRIBUTE_MAPPING];

  return (
    <AttributeMappingContainer className="flex justify-between">
      <div className="emailFilterRow">
        <div className="emailFilter">
          <Input
            value={emailFilter}
            data-testid="emailFilter"
            id="sushi-input"
            onChange={(e) => handleEmailFilterChange(e)}
            label="Email ID"
          />
        </div>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Button
            className={
              'sushi-btn ml-20 $isAddNewEnabled ? "enabled" : "disabled"'
            }
            disabled={!isApplyEnabled}
            onClick={handleApplyClick}
          >
            Apply
          </Button>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              className={
                'sushi-btn ml-20 $isAddNewEnabled ? "enabled" : "disabled"'
              }
              disabled={!isAddNewEnabled}
              onClick={() => handleClick("Add")}
            >
              Add New
            </Button>
          </Permission>
        </div>
      </div>
      <div className="actionFilterRow">
        <div className="actionFilter">
          <PaginatedReactDropdown
            options={actionList}
            disabled={!isActionFilterEnabled}
            data-testid="actionType"
            labelKey="label"
            valueKey="value"
            value={getInputLabel(initialActionType, actionList, "key", "label")}
            handleChange={handleActionFilterChange}
            keyToChange="action"
            placeholder="Select Action"
            showCross={false}
            id="actionTypeDropdown"
          />
        </div>

        <div className="buttons">
          <Button
            className={
              'sushi-btn ml-20 $isGetAttributeEnabled ? "enabled" : "disabled"'
            }
            disabled={!isGetAttributeEnabled}
            onClick={() => handleGetUserAttributeClick()}
          >
            Get User Attributes
          </Button>
        </div>
      </div>
    </AttributeMappingContainer>
  );
};

const AttributeMappingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;

  .emailFilterRow {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-grow: 1;
    margin-top: 2%;
  }

  .actionFilterRow {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-grow: 1;
  }

  .emailFilter,
  .actionFilter {
    flex-basis: 55%;
  }

  .actionBar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    margin-right: 2%;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: auto;
    margin-right: 2%;
  }
`;
const mapDispatchToProps = (dispatch) => {
  return {
    getUserAttributeList: bindActionCreators(
      AttributeMapping.getUserAttributeList,
      dispatch
    ),
    getActionTypeList: bindActionCreators(
      AttributeMapping.getActionTypeList,
      dispatch
    ),
  };
};

const mapStateToProps = (state) => {
  const { AttributeMapping } = state;
  return {
    currentState: AttributeMapping,
    userAttributeListData: AttributeMapping.userAttributeList ?? [],
    actionListData: AttributeMapping.actionList ?? [],
    userId: AttributeMapping.userId ?? 0,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttributeMappingTopSection);
